var _        = require('underscore');
var $        = require('jquery');

var Core        = require("ui-templates").Core;
var SidebarPackageGeneratorList = require('./sidebar__package__generator__list.js');
var SidebarPackageGeneratorForm = require('./sidebar__package__generator__form.js');
var SidebarPackageGeneratorRefImage = require('./sidebar__package__generator__ref__image.js');

/**
 * Creates a sidebar
 *
 * @class
 */

class SidebarPackageGenerator extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'title': 'Generators',
                'width': '200px',
                'theme': 'dark',
                'buttonTitle': 'Update Preview'
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__sidebar__package__generator js-editor__sidebar__package__generator">
                <div class="editor__sidebar__package__generator__header js-editor__sidebar__package__generator__header <%- theme %> ">
                    <div class="editor__sidebar__package__generator__back js-editor__sidebar__package__generator__back <%- theme %> "><%= embedded_svg('icon-dropdown-arrow') %></div>
                    <div class="editor__sidebar__package__generator__title js-editor__sidebar__package__generator__title <%- theme %> "><%- title %></div>
                    <div class="editor__sidebar__package__generator__search js-editor__sidebar__package__generator__search <%- theme %>">
                        <div class="editor__sidebar__package__generator__search__button js-editor__sidebar__package__generator__search__button <%- theme %>"><%= embedded_svg('icon-search') %></div>
                        <div class="editor__sidebar__package__generator__search__close__button js-editor__sidebar__package__generator__search__close__button <%- theme %>"><%= embedded_svg('icon-close') %></div>
                        <div class="editor__sidebar__package__generator__search__box js-editor__sidebar__package__generator__search__box">
                            <input class="editor__sidebar__package__generator__search__box__input js-editor__sidebar__package__generator__search__box__input" type="text" placeholder="Search Type"></input>
                        </div>
                    </div>
                    <div class="editor__sidebar__package__generator__finish__btn js-editor__sidebar__package__generator__finish__btn">
                        <a class='btn'>
                            <div class="btn__txt">Finish</div>
                        </a>
                    </div>
                    <div class="editor__sidebar__package__generator__fork__btn js-editor__sidebar__package__generator__fork__btn">
                        <a class='btn'>
                            <div class="btn__txt" title="Creates a new draft package starting from the parameters for this package.">Fork</div>
                        </a>
                    </div>
                </div>
                <div class="editor__sidebar__package__generator__input__container js-editor__sidebar__package__generator__input__container"></div>
                <div class="editor__sidebar__package__generator__button js-editor__sidebar__package__generator__button <%- theme %>" style="width:<%- width %>"><%- buttonTitle %></div>
            </div>
        `;

        super.render();

        $('.js-editor__sidebar__package__generator__back', this.$el).on('click', this._backButtonClicked);
        $('.js-editor__sidebar__package__generator__button', this.$el).on('click', this._updatePreviewButtonClicked);
        $('.js-editor__sidebar__package__generator__finish__btn', this.$el).on('click', this._FinishButtonClicked);
        $('.js-editor__sidebar__package__generator__fork__btn', this.$el).on('click', this._ForkButtonClicked);
        $('.js-editor__sidebar__package__generator__search__button', this.$el).on('click', this._packageSearchButtonClicked);
        $('.js-editor__sidebar__package__generator__search__close__button', this.$el).on('click', this._packageSearchCloseButtonClicked);
        $('.js-editor__sidebar__package__generator__search__box__input', this.$el).on('input', this._packageSearchBoxValueChanged);
        
        //initially hide buttons
        this.hideBackButton();
        this.hideUpdatePreviewButton();
    }

    addList() {
        return new SidebarPackageGeneratorList({
            target: $(".js-editor__sidebar__package__generator__input__container", this.$el),
            fields: {
              'theme': this._options.fields["theme"]
            }
        });
    }

    addForm() {
        return new SidebarPackageGeneratorForm({
            target: $(".js-editor__sidebar__package__generator__input__container", this.$el),
            fields: {
              'theme': this._options.fields["theme"]
            }
        });
    }

    addRefImage(imageUrl) {
        return new SidebarPackageGeneratorRefImage({
            target: $(".js-editor__sidebar__package__generator__input__container", this.$el),
            fields: {
                'imageUrl': imageUrl,
                'theme': this._options.fields["theme"]
            }
        });
    }

    _backButtonClicked(e) {
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:PackageGeneratorBackButton:clicked', e);
    }

    _updatePreviewButtonClicked(e) {
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:PackageGeneratorUpdatePreviewButton:clicked', e);
    }

    _FinishButtonClicked(e) {
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:PackageGeneratorFinishButton:clicked', e);
    }

    _ForkButtonClicked(e) {
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:PackageGeneratorForkButton:clicked', e);
    }

    _packageSearchButtonClicked(e) {
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:PackageGeneratorSearchButton:clicked', e);
    }

    _packageSearchCloseButtonClicked(e) {
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:PackageGeneratorSearchCloseButton:clicked', e);
    }

    _packageSearchBoxValueChanged(e){
        $(e.currentTarget).trigger('Cioui:PackageGeneratorSearchBox:value', $(e.currentTarget).val());
    }

    showBackButton() {
        $('.editor__sidebar__package__generator__back', this.$el).show();
    }

    hideBackButton() {
        $('.editor__sidebar__package__generator__back', this.$el).hide();
    }

    setTitle(title) {
        $('.editor__sidebar__package__generator__title', this.$el).html(title);
    }

    setUpdatePreviewButtonTitle(buttonTitle) {
        $('.editor__sidebar__package__generator__button', this.$el).html(buttonTitle);
    }

    showUpdatePreviewButton() {
        $('.editor__sidebar__package__generator__button', this.$el).show();
    }

    hideUpdatePreviewButton() {
        $('.editor__sidebar__package__generator__button', this.$el).hide();
    }

    enableUpdatePreviewButton() {
        $('.editor__sidebar__package__generator__button', this.$el).removeClass("disabled");
    }

    disableUpdatePreviewButton() {
        $('.editor__sidebar__package__generator__button', this.$el).addClass("disabled");
    }

    changeUpdatePreviewButtonColor() {
        $('.editor__sidebar__package__generator__button', this.$el).addClass("blue");
    }

    restoreUpdatePreviewButtonColor() {
        $('.editor__sidebar__package__generator__button', this.$el).removeClass("blue");
    }

    showFinishButton() {
        $('.editor__sidebar__package__generator__finish__btn', this.$el).show();
    }

    hideFinishButton() {
        $('.editor__sidebar__package__generator__finish__btn', this.$el).hide();
    }

    showForkButton() {
        $('.editor__sidebar__package__generator__fork__btn', this.$el).show();
    }

    hideForkButton() {
        $('.editor__sidebar__package__generator__fork__btn', this.$el).hide();
    }

    showPackageSearch() {
        $('.editor__sidebar__package__generator__search', this.$el).show();
    }

    hidePackageSearch() {
        $('.editor__sidebar__package__generator__search', this.$el).hide();
    }

    showPackageSearchButton() {
        $('.editor__sidebar__package__generator__search__button', this.$el).show();
    }

    hidePackageSearchButton() {
        $('.editor__sidebar__package__generator__search__button', this.$el).hide();
    }

    showPackageSearchCloseButton() {
        $('.editor__sidebar__package__generator__search__close__button', this.$el).show();
    }

    hidePackageSearchCloseButton() {
        $('.editor__sidebar__package__generator__search__close__button', this.$el).hide();
    }

    showPackageSearchBox() {
        $('.editor__sidebar__package__generator__search__box', this.$el).show();
        $('.editor__sidebar__package__generator__search__box__input', this.$el).focus();
    }

    hidePackageSearchBox() {
        $('.editor__sidebar__package__generator__search__box', this.$el).hide();
    }

    clearPackageSearchBox() {
        $('.editor__sidebar__package__generator__search__box__input', this.$el).val("");
    }
}

module.exports = SidebarPackageGenerator;
